import { createSlice } from "@reduxjs/toolkit";
import { getPropertiesEntry, getPropertiesTemplateService } from "../requests";
import { qrFramesInitialState } from "../../constants/common";

const qrFrames = createSlice({
  name: "qrSettings",
  initialState: qrFramesInitialState,
  reducers: {
    qrFrame(state, { payload }) {
      state.frame = payload;
    },
    qrFrameColor(state, { payload }) {
      state.frameColor = payload;
    },
    qrFrameTransform(state, { payload }) {
      state.frameTransform = payload;
    },
    qrFrameTransformText(state, { payload }) {
      state.transformFrameText = payload;
    },
    qrFrameTextColor(state, { payload }) {
      state.frameTextColor = payload;
    },
    qrFrameTextToggle(state, { payload }) {
      state.frameTextToggle = payload;
    },
    qrSetFrames(state, { payload }) {
      return payload;
    },
    qrFrameTextFont(state, { payload }) {
      state.frameTextFont = payload;
    },
    qrResetFrame() {
      return qrFramesInitialState;
    },
  },
  extraReducers: {
    [getPropertiesEntry.fulfilled]: (state, { payload }) => {
      if (payload.data.qrFrames) {
        setInitialFrames(state, payload);
      }
    },
    [getPropertiesTemplateService.fulfilled]: (state, { payload }) => {
      if (payload.data.qrFrames) {
        setInitialFrames(state, payload);
      }
    },
  },
});

const setInitialFrames = (state, payload) => {
  state.frame = payload.data.qrFrames.frame;
  state.frameColor = payload.data.qrFrames.frameColor;
  state.frameTransform = payload.frameTransform;
  state.transformFrameText = payload.transformFrameText;
  state.frameTextColor = payload.data.qrFrames.frameTextColor;
  state.frameTextToggle = payload.data.qrFrames.frameTextToggle;
  state.frameTextFont = payload.data.qrFrames.frameTextFont;
};

export const {
  qrFrame,
  qrFrameColor,
  qrFrameTransform,
  qrFrameTransformText,
  qrFrameTextColor,
  qrFrameTextToggle,
  qrSetFrames,
  qrFrameTextFont,
  qrResetFrame,
} = qrFrames.actions;
export default qrFrames.reducer;
